import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import { VehicleBrandDTO } from "../../shared/models/vehicle-brand-dto";
import { DISABLED_NOTIFY_MESSAGE } from "@core/constants";
import { SearchFormDTO } from "@shared/widgets/vehicle-brand-auto-complete/models/search-form-dto";

@Injectable({
  providedIn: "root"
})
export class VehicleBrandService {
  private vehicleBrandUrl = "brands/";
  private vehicleBrandPartsUrl = "model/get-brands/";
  private headers = new HttpHeaders({
    [DISABLED_NOTIFY_MESSAGE]: "true"
  });

  constructor(private http: HttpClient) {}

  save(vehicleBrandDTO: VehicleBrandDTO): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + this.vehicleBrandUrl,
      vehicleBrandDTO
    );
  }

  listAll(): Observable<VehicleBrandDTO[]> {
    return this.http.get<VehicleBrandDTO[]>(
      environment.apiUrl + this.vehicleBrandUrl
    );
  }

  listAllByFilters(searchFormDTO: SearchFormDTO): Observable<any[]> {
    let query = "";
    if (searchFormDTO.name) {
      query += `${searchFormDTO.name}`;
    }

    return this.http.get<any[]>(
      environment.microserviceParts + this.vehicleBrandPartsUrl + `${query}`
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      environment.apiUrl + `${this.vehicleBrandUrl}${id}`,
      {
        headers: this.headers
      }
    );
  }

  findById(id: number): Observable<VehicleBrandDTO> {
    return this.http.get<VehicleBrandDTO>(
      environment.apiUrl + `${this.vehicleBrandUrl}${id}`
    );
  }

  edit(id: number, vehicleBrandDTO: VehicleBrandDTO): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + `${this.vehicleBrandUrl}${id}`,
      vehicleBrandDTO
    );
  }
}
